export enum BatteryChargeState {
  BULK = 0,
  TOPUP = 1,
  FULL = 2,
  OVERTEMP = 3,
  DISCONNECTED = 4,
}
